import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import CustomerSelectionModal from "./CustomerSelectionModal";
import PartSelectionModal from "./PartSelectionModal";
import CustomerService from "../../../Customer/Controller/CustomerController";
import CustomerContactService from "../../../Customer/Controller/CustomerContactController";
import CustomerSiteService from "../../../Customer/Controller/CustomerSiteController";
import InvoiceService from "../../Controller/InvoiceController";
import VatTaxService from '../../../Setup/controller/VatTaxController/VatTaxController';

import CurrencyService from "../../../Setup/controller/CurrencyController/CurrencyController";
import CurrencyTextField from "../../../Jobs/View/JobForms/CurrencyTextField";
import { convertCurrency } from "../../../Purchasing/View/PurchaseOrderForms/CurrencyConverter";
import PartService from "../../../Parts/Controller/PartController";
import StockDiscountCategoryService from "../../../Parts/Controller/StockDiscountCategoryController";
import DiscountTypeService from "../../../Setup/controller/DiscountTypeController/DiscountTypeController";
import { handleChange, handleSubmit } from "../../Controller/CreateInvoiceController";
import HelpSite from "../../../Common/HelpLink";

import CustomerDiscountService from "../../../Customer/Controller/CustomerDiscountController";
import CustomerCategoryDiscountService from "../../../Customer/Controller/CustomerCategoryDiscountController"
import CustomerStockService from "../../../Customer/Controller/CustomerStockController";
import ShipInvoice from "../InvoiceForms/ShipInvoice";
import InvoiceShippedModel from "../InvoiceForms/InvoiceShippedModel";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import BASE_URL from "../../../../config/config";
import CompanySetupController from "../../../SuperAdmin/Controller/Client/SACompanyListController";
import Swal from 'sweetalert2';
import SendEmail from "../../../Common/SendEmailAttachment";
import ModuleService from "../../../Setup/controller/ModuleController/ModuleController";
import DescriptionModal from "./DescriptionModal";
import LeadUserDefineFieldsSection from '../../../Lead/Views/LeadForms/LeadUserDefineFieldsSection';
import JobUserDefineService from "../../../Jobs/Controller/UserDefineJobController";

import JasperReportService from '../../../Dashboard/Controller/JasperReportController';
import axiosInstance from '../../../../config/axiosInstance';
import { handleSubmit as handleUserDefineSubmit } from "../../../Jobs/Controller/CreateUserDefineController";
import ReportService from "../../../Setup/controller/ReportController/ReportController";
import TermsConditionService from "../../../Setup/controller/TermsConditionController/TermsConditionController";
import { PDFDocument } from "pdf-lib";
const MODULE_IDS = {
    Assets: 3,
    Parts: 4,
    Suppliers: 5,
    Quotations: 6,
    SalesOrders: 7,
    Purchasing: 8,
    Agreements: 9,
    Jobs: 10,
    Contacts: 15,
};
function CreateInvoice({ InvoiceID, onSuccess, ClientCompanyID, isLock, Tab, onClose }) {
    const navigate = useNavigate();
    const tableRef = useRef();
    const location = useLocation();
    const [errors, setErrors] = useState({});
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [imageData, setImageData] = useState(null);
    const [showShippedModal, setShowShippedModal] = useState(false);
    const [bnt_OrderNumber, set_bnt_OrderNumber] = useState("");
    const [assignedModules, setAssignedModules] = useState(new Set());

    const [reportLink, setReportLink] = useState('');
    const [reportTitle, setReportTitle] = useState('');
    const [error, setError] = useState(null);
    const getCurrentDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };

    const [showDescriptionModal, setShowDescriptionModal] = useState(false);
    const [descriptionText, setDescriptionText] = useState("");
    const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
    const [stockLocationList, setStockLocationList] = useState([]);
    const [isChanged, setIsChanged] = useState(false);
    const [includeTerms, setIncludeTerms] = useState(true);
    const [formData, setFormData] = useState({
        CustomerID: 0,
        CustomerName: '',
        FK_ClientBranch_ID: 0,
        FK_ClientContact_ID: 0,
        AccountRef: '',
        dec_DiscountAmount: "0.00",
        mon_TotalPrice: "0.00",
        GrandTotal: "0.00",
        dec_DiscountNETTotal: "0",
        vc_CustomerOrderNumber: "",
        dt_InvoiceDate: getCurrentDate(),
        dt_DueDate: getCurrentDate(),
        PaymentTermID: "1",
        int_DiscountType: 0,
        IsPercentage: false,
        mon_TotalPriceO: "0.00",
        mon_TotalPriceGR: "0.00",
        FK_Issue_ID: "0",
        vc_User5: "",
        snt_PaymentMethod: "0",
        FK_InvoiceType_ID: "1",
        dec_CurrencyToBaseRate: "1.00",
        HostCompanyAddress: "",
        bnt_OrderNumber: "",

        vc_DeliveryFullName: "",
        vc_DeliveryAddress1: "",
        vc_DeliveryTown: "",
        vc_DeliveryCounty: "",
        vc_DeliveryPostCode: "",
        CourierID: "0",
        ClientType: "0",
        ClientCompanyName: "",
        Forename: "",
        Address1: "",
        Surname: ""

    });
    const [CustomerList, setCustomer] = useState([]);
    const [CustomerContactList, setCustomerContact] = useState([]);
    const [CustomerSiteList, setCustomerSite] = useState([]);
    const [showCustomerModal, setShowCustomerModal] = useState(false);
    const [InvoiceTypeList, setInvoiceTypeData] = useState([]);
    const [PaymentTermList, setPaymentTermList] = useState([]);
    const { theme } = useContext(ThemeContext);
    const [partList, setPartData] = useState([]);
    const [InvoiceItems, setInvoiceItems] = useState([]);
    const [selectedParts, setSelectedParts] = useState([]);
    const [showPartModal, setShowPartModal] = useState(false);
    const [DiscountsList, setDiscounts] = useState([]);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [vatTax, setVatTax] = useState('0.00');
    const [convRate, setConRate] = useState('0.00');
    const [pdfUrl, setPdfUrl] = useState(null); // State to store the PDF URL
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [customerTax, setCustomerTax] = useState("0.00");
    const [customertaxType, setCustomertaxType] = useState("0");

    const [customerCategorytaxType, setCustomerCategoryType] = useState("0");
    const [customerCategoryTax, setCustomerCategoryTax] = useState("0");
    const [quantityTax, setQuantityTax] = useState("0");

    const [quantityBreak, setQuantityBreak] = useState();
    const [customerStockList, setCustomerStockList] = useState([]);

    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    const [currencyList, setCurrencies] = useState([]);
    const [currencyCustomerSymbol1, setCurrencyCustomerSymbol1] = useState('');
    const [currencyCostValue1, setCostCurrencyValue1] = useState('');
    const [BaseCurrency, setBaseCurrency] = useState('');
    const [StockLocationList, setStockLocation] = useState([]);
    const [InvoiceItemHistory, setInvoiceItemHistory] = useState([]);
    const [ShowInvoiceHistoryModal, setShowInvoiceHistoryModal] = useState(false);
    const [isClosed, SetIsClosed] = useState("0");
    const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
    const [Email, setEmail] = useState();
    const [pdfBlob, setPdfBlob] = useState(null);
    const [pdfAttachment, setPdfAttachment] = useState(null); // Store PDF for Email
    const [loading, setLoading] = useState(false);
    const [KeyNameList, setKeyNames] = useState([]);
    const [saleItemID, setSaleItemID] = useState(null);
    const [showDepotModal, setShowDepotModal] = useState(false);
    const [activePartId, setActivePartId] = useState(null);
    const [selectedDepot, setSelectedDepot] = useState({});
    const fetchKeyNames = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const KeyNames = await JobUserDefineService.GetJobUserDefine(redirectCallback, InvoiceID, "22");
            setKeyNames(KeyNames || []);

            // Initialize form data with vc_Value if available
            const initialFormData = {};
            KeyNames.forEach(keyItem => {
                if (keyItem.vc_Value) {
                    initialFormData[keyItem.vc_Name] = keyItem.vc_Value;
                }
            });

            // ✅ Merge into existing formData instead of replacing it
            setFormData(prev => ({
                ...prev,
                ...initialFormData
            }));
        } catch (error) {
            console.error('Error fetching Key Names:', error);
        }
    };

    const handleIntegerChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*$/.test(value)) {
            setFormData(prevData => ({ ...prevData, [name]: value }));
        }
    };

    const handleDecimalChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*\.?\d*$/.test(value)) {
            setFormData(prevData => ({ ...prevData, [name]: value }));
        }
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData(prevData => ({ ...prevData, [name]: files[0] }));
    };
    const fetchCurrency = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const currencyData = await CurrencyService.GetAllCurrencies(redirectCallback);
            setCurrencies(currencyData);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const fetchDefaultCurrency = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfCurreny = await CurrencyService.DefaultCurrency(redirectCallback);
            setBaseCurrency(listOfCurreny[0].Symbol);

        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };
    const fetchVatTax = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const vatTax = await VatTaxService.GetVatTaxLabel(redirectCallback);
            if (vatTax.length > 0) {
                setVatTax(vatTax[0].vatTax);
            }
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    useEffect(() => {
        SetIsClosed("0");
        fetchCurrency();
        fetchDefaultCurrency();
        //fetchVatTax();
        fetchCustomers();
        fetchInvoiceType();
        fetchPaymentTerm();
        fetchAssignedModules();
        if (InvoiceID > 0) {
            fetchInvoiceDetail();
            fetchKeyNames();

        }
        else {
            resetForm();
            setSelectedParts([]);
            if (ClientCompanyID > 0) {
                fetchCustomerData(ClientCompanyID);
            }
            fetchKeyNames();
        }
        //fetchParts();
        fetchDiscount();

    }, [InvoiceID, Tab]);

    useEffect(() => {
        const updatedParts = selectedParts.map(part => {
            const salesPrice = parseFloat(part.mon_SalesPrice || 0);
            const netSalesPrice = parseFloat(part.net_SalesPrice || 0);
            const netVATPrice = parseFloat(part.net_VATPrice || 0);
            const quantity = parseFloat(part.vc_UnitOfSale || 0);
            const dec_Discount = parseFloat(part.dec_Discount || 0);
            const discount = (salesPrice * quantity) * ((dec_Discount) / 100);
            const total = netSalesPrice; // Assuming total is just the net sales price
            const totalVAT = netVATPrice;
            return { ...part, discount, total, totalVAT };
        });

        const totalSalesPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.mon_SalesPrice || 0), 0);
        let totalNetSalesPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.total || 0), 0);
        let totalDiscountedAmount = updatedParts.reduce((sum, part) => sum + parseFloat(part.dec_Discount || 0), 0);
        const totalVATPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.totalVAT || 0), 0);
        const carriage = parseFloat(formData.mon_DeliveryNetTotal || 0);
        if (formData.int_DiscountType === "3" || formData.int_DiscountType === 3) {
         //   totalDiscountedAmount = Math.round(parseFloat(totalDiscountedAmount).toFixed(2)) + Math.round(parseFloat((totalNetSalesPrice * formData.dec_DiscountAmount) / 100).toFixed(2));
            totalDiscountedAmount = parseFloat(parseFloat(totalDiscountedAmount) +(totalNetSalesPrice * formData.dec_DiscountAmount) / 100).toFixed(2);
            totalNetSalesPrice = (totalNetSalesPrice) * ((100 - formData.dec_DiscountAmount) / 100);

        }
        else if (formData.int_DiscountType === "4" || formData.int_DiscountType === 4) {
            totalDiscountedAmount = Math.round(totalDiscountedAmount) + Math.round(formData.dec_DiscountAmount);
            totalNetSalesPrice = totalNetSalesPrice - formData.dec_DiscountAmount;

        }
        const orderTotal = parseFloat(totalNetSalesPrice).toFixed(2);
        const grandTotal = parseFloat(totalNetSalesPrice + totalVATPrice + carriage).toFixed(2);
        setFormData((prevFormData) => ({
            ...prevFormData,
            dec_DiscountNETTotal: parseFloat(totalDiscountedAmount).toFixed(2),
            mon_TotalPrice: parseFloat(orderTotal).toFixed(2),
            mon_TotalPriceO: parseFloat(totalVATPrice).toFixed(2),
            mon_TotalPriceG: grandTotal

        }));
    }, [selectedParts, formData.int_DiscountType, formData.dec_DiscountAmount, formData.mon_DeliveryNetTotal]);


    const fetchCustomers = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfCustomers = await CustomerService.GetAllCustomers(redirectCallback);
            setCustomer(listOfCustomers);
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };
    const fetchInvoiceType = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const list = await InvoiceService.GetInvoiceType(redirectCallback);
            setInvoiceTypeData(list);
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };
    const fetchPaymentTerm = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const list = await InvoiceService.GetPaymentTerms();
            setPaymentTermList(list);
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };

    const fetchDiscount = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfDiscounts = await DiscountTypeService.GetAllDiscountTypes(redirectCallback);
            setDiscounts(listOfDiscounts);
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };

    const fetchDiscountCategory = async (CustomerID) => {
        try {
            const redirectCallback = () => navigate('/');
            let listOfDiscounts = await CustomerDiscountService.GetAllCustomerDiscount(redirectCallback, CustomerID);
            listOfDiscounts = listOfDiscounts.find(cust => cust.IsDefault === 1);
            return listOfDiscounts;
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };
    const fetchCustomerCategoryDiscount = async (StockCategoryID) => {
        try {
            const redirectCallback = () => navigate('/');
            let listOfDiscounts = await PartService.QuantityBreakDiscount(redirectCallback, StockCategoryID);
            return listOfDiscounts;
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };
    const fetchCustomerStock = async (CustomerID) => {
        try {
            debugger;
            const redirectCallback = () => navigate('/');
            const stockList = await CustomerStockService.CustomerStockCategory(redirectCallback, CustomerID);
            debugger;
            return stockList;

        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };


    const fetchCustomerContact = async (BranchID) => {
        try {

            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            setCustomerContact([]);
            const listOfCustomerContacts = await CustomerContactService.GetContactByBranch(redirectCallback, BranchID);
            setCustomerContact(listOfCustomerContacts);
            if (listOfCustomerContacts.length > 0) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    FK_ClientContact_ID: listOfCustomerContacts[0].ClientContactID,
                }));
            }
        } catch (error) {
            console.error('Error fetching customer contacts:', error);
        }
    };

    const fetchCustomersSites = async (customerID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const listOfCustomerSites = await CustomerSiteService.GetAllCustomersSites(redirectCallback, customerID);
            setCustomerSite(listOfCustomerSites);
            const headOfficeSite = listOfCustomerSites.find(site => site.HeadOffice === 1);
            if (headOfficeSite) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    FK_ClientBranch_ID: headOfficeSite.ClientBranchID,
                }));
                await fetchCustomerContact(headOfficeSite.ClientBranchID);
            } else if (listOfCustomerSites.length > 0) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    FK_ClientBranch_ID: headOfficeSite.ClientBranchID,
                }));
                await fetchCustomerContact(listOfCustomerSites[0].ClientBranchID);
            }
        } catch (error) {
            console.error('Error fetching customer sites:', error);
        }
    };
    const populateCustomerSiteContactAccount = async (quotation) => {

        const redirectCallback = () => navigate('/');
        const customerId = quotation.CustomerID;
        const listOfCustomers = await CustomerService.GetAllCustomers(redirectCallback);
        const selectedCustomer = listOfCustomers.find(customer => customer.ClientCompanyID === parseInt(customerId));

        const listOfCurreny = await CurrencyService.DefaultCurrency(redirectCallback);
        const newCurrencySymbol = (selectedCustomer.vc_CurrencySymbol != null && selectedCustomer.vc_CurrencySymbol !== "" && selectedCustomer.vc_CurrencySymbol !== "undefined")
            ? selectedCustomer.vc_CurrencySymbol
            : listOfCurreny[0].Symbol;
        //  fetchParts(selectedCustomer.ClientCompanyID);
        setVatTax(selectedCustomer.dec_Rate);
        setCustomerTax(selectedCustomer.dec_Amount ?? 0.00);
        setCustomertaxType(selectedCustomer.FK_DiscountType_ID ?? 0);

        //Level 2 Discounting

        const CustomerStock = await fetchCustomerStock(selectedCustomer.ClientCompanyID);
        if (CustomerStock.length > 0) {
            setCustomerCategoryType(CustomerStock[0].FK_DiscountType_ID);
            setCustomerCategoryTax(CustomerStock[0].dec_Amount);

            const StockCategryList = await StockDiscountCategoryService.GetStockByCategoryID(redirectCallback, CustomerStock[0].FK_StockCategory_ID);
            setCustomerStockList(StockCategryList);
            // Level 3 Discount
            let QuantityBreakDiscount = await fetchCustomerCategoryDiscount(CustomerStock[0].FK_StockCategory_ID);
            setQuantityBreak(QuantityBreakDiscount);
        }


        let ConvRate = "1.00";

        if (selectedCustomer.vc_CurrencySymbol != null && selectedCustomer.vc_CurrencySymbol != "" && selectedCustomer.vc_CurrencySymbol != "undefined") {
            setCurrencyCustomerSymbol1(selectedCustomer.vc_CurrencySymbol);
            ConvRate = await convertCurrency(BaseCurrency, selectedCustomer.vc_CurrencySymbol, currencyList, "0");
            setConRate(ConvRate);
        }
        else {
            setCurrencyCustomerSymbol1(listOfCurreny[0].Symbol);
            ConvRate = await convertCurrency(listOfCurreny[0].Symbol, listOfCurreny[0].Symbol, currencyList, "0");
            setConRate(ConvRate);
        }
        await fetchQuotationItems(newCurrencySymbol, ConvRate);

        await fetchCustomersSites(customerId);
        await fetchCustomerContact(quotation.FK_ClientBranch_ID);

        setFormData(prev => ({
            ...prev,
            ...quotation,
            CustomerID: customerId,
            AccountRef: quotation.AccountRef,
            FK_ClientBranch_ID: quotation.FK_ClientBranch_ID,
            FK_ClientContact_ID: quotation.FK_ClientContact_ID,
            dt_InvoiceDate: new Date(quotation.dt_InvoiceDate).toISOString().split('T')[0],
            dt_DueDate: new Date(quotation.dt_DueDate).toISOString().split('T')[0],
            dec_CurrencyToBaseRate: quotation.dec_CurrencyToBaseRate
        }));

    };
    const fetchParts = async (ClientCompanyID = 0) => {
        try {
            const redirectCallback = () => navigate('/');
            const data = await InvoiceService.GetAllParts(redirectCallback, ClientCompanyID);
            setPartData(data);
        } catch (error) {
            console.error('Error fetching parts:', error);
        }
    };
    const fetchInvoice = async (InvoiceID) => {
        try {
            const redirectCallback = () => navigate('/');
            if (InvoiceID > 0) {
                const saleOrderDetail = await InvoiceService.GetInvoiceByID(redirectCallback, InvoiceID);
                const saleOrder = saleOrderDetail[0];
                return saleOrder;
            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };
    const fetchInvoiceDetail = async () => {
        try {
            const redirectCallback = () => navigate('/');

            if (InvoiceID > 0) {
                const saleOrderDetail = await InvoiceService.GetInvoiceByID(redirectCallback, InvoiceID);

                const saleOrder = saleOrderDetail[0];
                setEmail(saleOrder.Email);
                setFormData(prev => ({
                    ...prev,
                    ...saleOrder,
                    dt_InvoiceDate: new Date(saleOrderDetail[0].dt_InvoiceDate).toISOString().split('T')[0],
                    dt_DueDate: new Date(saleOrderDetail[0].dt_DueDate).toISOString().split('T')[0],
                    CustomerName: saleOrder.CompanyName,
                    HostCompanyAddress: saleOrder.HostCompanyAddress,
                    bnt_OrderNumber: saleOrder.bnt_OrderNumber,
                    vc_DeliveryFullName: saleOrder.vc_DeliveryFullName,
                    vc_DeliveryAddress1: saleOrder.vc_DeliveryAddress1,
                    vc_DeliveryTown: saleOrder.vc_DeliveryTown,
                    vc_DeliveryCounty: saleOrder.vc_DeliveryCounty,
                    vc_DeliveryPostCode: saleOrder.vc_DeliveryPostCode
                }));

                if (saleOrder.bit_DropShipment > 0 || saleOrder.bit_DropShipment > "0") {
                    SetIsClosed("1");
                }

                /* if (saleOrder.FK_Issue_ID > 0 || saleOrder.FK_SaleOrder_ID > 0) {
                     SetIsClosed("1");
                 }*/

                if (saleOrder.snt_AllocatedStatus > 0 || saleOrder.snt_AllocatedStatus > "0") {
                    SetIsClosed("1");
                }
                await populateCustomerSiteContactAccount(saleOrderDetail[0]);
            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };
    const handleBranchChange = async (event) => {
        const { value } = event.target;
        const branchID = event.target.value;
        setFormData({
            ...formData,
            FK_ClientBranch_ID: value,
            FK_ClientContact_ID: 0
        });
        await fetchCustomerContact(value);

    };
    const fetchCustomerData = async (customerID) => {
        try {
            const redirectCallback = () => navigate('/');
            const customerData = await CustomerService.GetCustomerByID(redirectCallback, customerID);

            if (customerData.length > 0) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    CustomerName: customerData[0].CompanyName,
                    AccountRef: customerData[0].AccountRef,
                    HostCompanyAddress: customerData[0].HostCompanyAddress,
                    bnt_OrderNumber: customerData[0].bnt_OrderNumber,

                    vc_DeliveryFullName: customerData[0].vc_DeliveryFullName,
                    vc_DeliveryAddress1: customerData[0].vc_DeliveryAddress1,
                    vc_DeliveryTown: customerData[0].vc_DeliveryTown,
                    vc_DeliveryCounty: customerData[0].vc_DeliveryCounty,
                    vc_DeliveryPostCode: customerData[0].vc_DeliveryPostCode
                }));
            }
            let ConvRate = "1.00";

            if (customerData[0].vc_CurrencySymbol != null && customerData[0].vc_CurrencySymbol != "" && customerData[0].vc_CurrencySymbol != "undefined") {
                setCurrencyCustomerSymbol1(customerData[0].vc_CurrencySymbol);
                ConvRate = await convertCurrency(BaseCurrency, customerData[0].vc_CurrencySymbol, currencyList, "0");
            }
            else {
                const listOfCurreny = await CurrencyService.DefaultCurrency(redirectCallback);
                setCurrencyCustomerSymbol1(listOfCurreny[0].Symbol);
                ConvRate = "1.00";
            }
            handleCustomerSelect(customerData[0]);
            await fetchCustomerContact(customerID);
            await fetchCustomersSites(customerID);
            await fetchQuotationItems(customerData[0].vc_CurrencySymbol, ConvRate);
        } catch (error) {
            console.error('Error fetching customer data:', error);
        }
    };

    const handleFieldChange = (event) => {
        const { name, value } = event.target;
        setIsChanged(true);
        // Allow input of decimal points
        const isDecimalInput = name === "dec_DiscountAmount" && /^-?\d*\.?\d*$/.test(value);
        if (!isDecimalInput && name === "dec_DiscountAmount") return;

        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value
        }));

        if (name === "int_DiscountType" || name === "dec_DiscountAmount") {
            const discountValue = name === "int_DiscountType" ? value : formData.int_DiscountType;
            let amountValue = name === "dec_DiscountAmount" ? value : formData.dec_DiscountAmount;

            if (discountValue === "0") {
                amountValue = "0";
            }

            setFormData((prevFormData) => ({
                ...prevFormData,
                int_DiscountType: discountValue,
                dec_DiscountAmount: amountValue,

            }));
        }
    };

    const calculateQuantityBreakDiscount = (quantity, StockID) => {
        const qBreak = quantityBreak.filter(discount => discount.PK_Stock_ID === StockID && ((discount.snt_QuantityBreak || 0) <= quantity))
            .sort((a, b) => (b.snt_QuantityBreak || 0) - (a.snt_QuantityBreak || 0))[0];
        if (qBreak) {
            return qBreak.dec_Discount;
        }
        else {
            return "0";
        }
    }

    // Calculation function
    const calculateNetSalesPrice = (salesPrice, discountAmount, isPercentage, dec_Quantity, dec_Discount, StockID) => {
        //Customer Discount 

        let TotalAmount = (salesPrice * dec_Quantity);
        if (customertaxType === "3" || customertaxType === 3) {
            TotalAmount = (TotalAmount) * ((100 - customerTax) / 100);
        }
        if (customertaxType === "4" || customertaxType === 4) {
            TotalAmount = TotalAmount - customerTax;
        }
        // END Customer Discount
        const StockDetail = customerStockList.filter(x => x.FK_Stock_ID === StockID);
        if (StockDetail.length > 0) {
            //Customer Discount Category 1
            if (customerCategorytaxType === "3" || customerCategorytaxType === 3) {
                TotalAmount = (TotalAmount) * ((100 - customerCategoryTax) / 100);
            }
            if (customerCategorytaxType === "4" || customerCategorytaxType === 4) {
                TotalAmount = TotalAmount - customerCategoryTax;
            }
            //END Customer Discount Category 1
            //Level 3 Discount
            const QuanitityDiscount = calculateQuantityBreakDiscount(dec_Quantity, StockID);
            if (quantityBreak.length > 0) {
                TotalAmount = (TotalAmount) * ((parseFloat(100).toFixed(2) - parseFloat(QuanitityDiscount).toFixed(2)) / 100);
            }
        }
        return parseFloat(TotalAmount).toFixed(2);
    };
    const calculateDiscountAmount = (salesPrice, discountAmount, isPercentage, dec_Quantity, dec_Discount, StockID) => {

        //Customer Discount 
        let TotalAmount = (salesPrice * dec_Quantity);
        let cusDiscountAmount = 0;
        if (customertaxType === "3" || customertaxType === 3) {
            cusDiscountAmount = (TotalAmount) * (customerTax / 100);
            TotalAmount = (TotalAmount) * ((100 - customerTax) / 100);
        }
        if (customertaxType === "4" || customertaxType === 4) {
            cusDiscountAmount = customerTax;
            TotalAmount = TotalAmount - customerTax;
        }
        //End Customer Discount 
        //Customer Discount Category 1
        const StockDetail = customerStockList.filter(x => x.FK_Stock_ID === StockID);
        if (StockDetail.length > 0) {
            if (customerCategorytaxType === "3" || customerCategorytaxType === 3) {
                cusDiscountAmount = Math.round(parseFloat(cusDiscountAmount).toFixed(2)) + Math.round(parseFloat((TotalAmount) * (customerCategoryTax / 100)).toFixed(2));
                TotalAmount = (TotalAmount) * ((100 - customerCategoryTax) / 100);
            }
            if (customerCategorytaxType === "4" || customerCategorytaxType === 4) {
                cusDiscountAmount = Math.round(parseFloat(cusDiscountAmount).toFixed(2)) + Math.round(parseFloat(customerCategoryTax).toFixed(2));
                TotalAmount = TotalAmount - customerCategoryTax;
            }
            //END Customer Discount Category 1
            //Level 3 Discount
            const QuanitityDiscount = calculateQuantityBreakDiscount(dec_Quantity, StockID);
            if (quantityBreak.length > 0) {
                cusDiscountAmount = Math.round(parseFloat(cusDiscountAmount).toFixed(2)) + Math.round(parseFloat((TotalAmount) * (QuanitityDiscount / 100)).toFixed(2));
                TotalAmount = (TotalAmount) * ((parseFloat(100).toFixed(2) - parseFloat(QuanitityDiscount).toFixed(2)) / 100);
            }
        }
        //End Level 3 Discoutn
        return parseFloat(cusDiscountAmount).toFixed(2);
    };
    const calculateDiscountPrice = (salesPrice, discountAmount, isPercentage, dec_Quantity, dec_Discount, StockID) => {
        const vatTaxPercent = vatTax;

        //Customer Discount
        let TotalAmount = (salesPrice * dec_Quantity);
        if (customertaxType === "3" || customertaxType === 3) {
            TotalAmount = (TotalAmount) * ((100 - customerTax) / 100);
        }
        if (customertaxType === "4" || customertaxType === 4) {
            TotalAmount = TotalAmount - customerTax;

        }
        // END Customer Discount
        //Customer Discount Category 1
        const StockDetail = customerStockList.filter(x => x.FK_Stock_ID === StockID);
        if (StockDetail.length > 0) {
            if (customerCategorytaxType === "3" || customerCategorytaxType === 3) {
                TotalAmount = (TotalAmount) * ((100 - customerCategoryTax) / 100);
            }
            if (customerCategorytaxType === "4" || customerCategorytaxType === 4) {
                TotalAmount = TotalAmount - customerCategoryTax;

            }
            //End Customer Discount Category 1
            //Level 3 Discount
            const QuanitityDiscount = calculateQuantityBreakDiscount(dec_Quantity, StockID);
            if (quantityBreak.length > 0) {
                TotalAmount = (TotalAmount) * ((parseFloat(100).toFixed(2) - parseFloat(QuanitityDiscount).toFixed(2)) / 100);
            }
        }
        // End Level 3 Discount
        let newPrice = (TotalAmount * vatTaxPercent) / 100;
        return (newPrice).toFixed(2);
    };

    const handleSalesPriceChange = (index, newSalesPrice, fieldName) => {
        if (fieldName === "mon_SalesPrice") {
            const updatedParts = selectedParts.map((part, i) => {
                if (i === index) {
                    const netPrice = calculateNetSalesPrice(newSalesPrice.value, formData.dec_DiscountAmount, formData.int_DiscountType, part.vc_UnitOfSale, part.dec_Discount, part.PK_Stock_ID);
                    const VATPrice = calculateDiscountPrice(newSalesPrice.value, formData.dec_DiscountAmount, formData.int_DiscountType, part.vc_UnitOfSale, part.dec_Discount, part.PK_Stock_ID);
                    const dec_Discount = calculateDiscountAmount(newSalesPrice.value, formData.dec_DiscountAmount, formData.int_DiscountType, part.vc_UnitOfSale, part.dec_Discount, part.PK_Stock_ID);
                    return {
                        ...part,
                        mon_SalesPrice: newSalesPrice.value,
                        net_SalesPrice: netPrice,
                        net_VATPrice: VATPrice,
                        dec_Discount: dec_Discount
                    };
                }
                return part;
            });
            setSelectedParts(updatedParts);
        }
        else if (fieldName === "dec_Quantity") {

            const updatedParts = selectedParts.map((part, i) => {
                if (i === index) {


                    const netPrice = calculateNetSalesPrice(part.mon_SalesPrice, formData.dec_DiscountAmount, formData.int_DiscountType, newSalesPrice.value, part.dec_Discount, part.PK_Stock_ID);
                    const VATPrice = calculateDiscountPrice(part.mon_SalesPrice, formData.dec_DiscountAmount, formData.int_DiscountType, newSalesPrice.value, part.dec_Discount, part.PK_Stock_ID);
                    const dec_Discount = calculateDiscountAmount(newSalesPrice.value, formData.dec_DiscountAmount, formData.int_DiscountType, part.vc_UnitOfSale, part.dec_Discount, part.PK_Stock_ID);
                    return {
                        ...part,
                        dec_Quantity: newSalesPrice.value,
                        net_SalesPrice: netPrice,
                        net_VATPrice: VATPrice,
                        dec_Discount: dec_Discount
                    };
                }
                return part;
            });

            // Calculate the sum of mon_SalesPrice and net_SalesPrice
            let totalDiscountedAmount = 0;
            if (formData.int_DiscountType === "3") {
                const totalSalesPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.mon_StockPrice), 0);
                const totalNetSalesPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.net_SalesPrice), 0);
                totalDiscountedAmount = totalSalesPrice - totalNetSalesPrice;
            }
            else if (formData.int_DiscountType === "4") {

                totalDiscountedAmount = updatedParts.reduce((sum, part) => sum + parseFloat(part.dec_Discount), 0);
            }
            // Update the state with the new parts and the total discounted amount
            setSelectedParts(updatedParts);

        }
    };


    const handleQuantityChange = (index, newSalesPrice) => {
        const updatedParts = selectedParts.map((part, i) => {
            if (i === index) {
                const netPrice = calculateNetSalesPrice(part.mon_SalesPrice, formData.dec_DiscountAmount, formData.int_DiscountType, newSalesPrice, part.dec_Discount, part.PK_Stock_ID);
                const VATPrice = calculateDiscountPrice(part.mon_SalesPrice, formData.dec_DiscountAmount, formData.int_DiscountType, newSalesPrice, part.dec_Discount, part.PK_Stock_ID);
                const dec_Discount = calculateDiscountAmount(part.mon_SalesPrice, formData.dec_DiscountAmount, formData.int_DiscountType, newSalesPrice, part.dec_Discount, part.PK_Stock_ID);
                return {
                    ...part,
                    vc_UnitOfSale: newSalesPrice,
                    net_SalesPrice: netPrice,
                    net_VATPrice: VATPrice,
                    dec_Discount: dec_Discount
                };
            }
            return part;
        });

        // Calculate the sum of mon_SalesPrice and net_SalesPrice
        let totalDiscountedAmount = 0;
        if (formData.int_DiscountType === "3") {
            const totalSalesPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.mon_SalesPrice), 0);
            const totalNetSalesPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.net_SalesPrice), 0);
            const totalDiscountedAmount = totalSalesPrice - totalNetSalesPrice;
        }
        else if (formData.int_DiscountType === "4") {
            totalDiscountedAmount = updatedParts.reduce((sum, part) => sum + parseFloat(part.dec_Discount), 0);
        }
        // Update the state with the new parts and the total discounted amount
        setSelectedParts(updatedParts);

    };





    const handlePartChange = (event, index, fieldName) => {
        const { value } = event.target;
        const updatedParts = [...selectedParts];
        const part = updatedParts[index];
        part[fieldName] = value;

        if (fieldName === "mon_SalesPrice") {

            part.net_SalesPrice = calculateNetSalesPrice(value, formData.dec_DiscountAmount, formData.IsPercentage, part.vc_UnitOfSale, part.dec_Discount);
            part.net_VATPrice = calculateDiscountPrice(value, formData.dec_DiscountAmount, formData.IsPercentage, part.vc_UnitOfSale, part.dec_Discount);
        }

        setSelectedParts(updatedParts);
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();

        try {
            const redirectUserList = () => {
                navigate('/InvoiceList?saved=true');
            };

            formData.FK_InvoiceStatus_ID = "1";
            formData.PK_Invoice_ID = InvoiceID;
            formData.snt_PaymentMethod = "1";
            // formData.mon_DeliveryNetTotal = "0.00";
            formData.mon_DeliveryVATTotal = "0.00";
            formData.FK_InvoiceSource_ID = "1";
            formData.FK_Currency_ID = currencyCustomerSymbol1;
            formData.currencyCustomerSymbol1 = currencyCustomerSymbol1 || BaseCurrency;
            formData.BaseCurrency = BaseCurrency;
            const targetCurrency = currencyCustomerSymbol1 || BaseCurrency;
            let IsError = "0";
            const ConversionRate = await convertCurrency(BaseCurrency, targetCurrency, currencyList, "0");
            const selectedPartsData = await Promise.all(selectedParts.map(async (detail) => {
                const convertedStockPrice = (detail.mon_StockPrice / ConversionRate);
                const convertedmon_SalesPrice = (detail.mon_SalesPrice / ConversionRate);
                const convertednet_SalesPrice = (detail.net_SalesPrice / ConversionRate);
                const converteddetailnet_VATPrice = (detail.net_VATPrice / ConversionRate);
                const convertedmon_SellingPrice = (detail.mon_SellingPrice / ConversionRate);

                if (detail.PK_Stock_ID > 0 && detail.StockType > 0) {

                    if (detail.PK_StockLocation_ID == "0") {
                        IsError = "1";
                        Swal.fire(
                            'Warning',
                            'Please select depot for all stock items',
                            'Warning'
                        );
                        return false;
                    }
                }
                return {
                    vc_StockCode: detail.vc_StockCode,
                    vc_Description: detail.vc_Description,
                    mon_StockPrice: convertedStockPrice, // Use the converted price
                    mon_SalesPrice: convertedmon_SalesPrice,
                    dec_Quantity: detail.dec_Quantity,
                    vc_UnitOfSale: detail.vc_UnitOfSale,
                    net_SalesPrice: convertednet_SalesPrice,
                    net_VATPrice: converteddetailnet_VATPrice,
                    vc_StockName: detail.vc_Description,
                    PK_Stock_ID: detail.FK_Stock_ID,
                    dec_Discount: detail.dec_Discount,
                    mon_SellingPrice: convertedmon_SellingPrice,
                    vc_CommodityCode: detail.vc_CommodityCode,
                    dec_TaxCode: detail.dec_TaxCode,
                    dec_UnitWeight: detail.dec_UnitWeight,
                    snt_PurchaseNominalCode: detail.snt_PurchaseNominalCode,
                    dec_VAT: detail.dec_VAT,
                    mon_VATPriceForeignCurrency: detail.mon_VATPriceForeignCurrency,
                    PK_Stock_ID: detail.PK_Stock_ID,
                    PK_StockLocation_ID: detail.PK_StockLocation_ID,
                    DepotQuantity: detail.DepotQuantity
                };
            }));

            const formDataWithParts = {
                formData: formData,
                selectedParts: selectedPartsData
            };
            if (IsError === "0") {
                const message = await handleSubmit(event, formDataWithParts, setFormData, setErrors);

                if (message == "Data saved successfully") {
                    setIsChanged(false);
                    onSuccess();
                    await handleUserDefineSubmit({
                        JobID: localStorage.getItem('InvoiceID'),
                        fields: KeyNameList.map(key => ({
                            PK_KeyName_ID: key.PK_KeyName_ID,
                            value: formData[key.vc_Name] || ''
                        }))
                    });
                    InvoiceID = localStorage.getItem('InvoiceID');
                    fetchKeyNames();
                    localStorage.setItem('HasRecordUpdated', "1");
                    setShowSuccessMessage(true);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    setTimeout(() => {
                        setShowSuccessMessage(false);
                    }, 5000);

                }
                else {
                    setShowErrorMessage(true);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    setTimeout(() => {
                        setShowErrorMessage(false);
                    }, 5000);

                }
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            setErrors({ submit: 'An error occurred while submitting the form. Please try again.' });
        }
    };

    const handleCustomerSelect = async (customer) => {
        setIsChanged(true);

        const newCurrencySymbol = (customer.vc_CurrencySymbol != null && customer.vc_CurrencySymbol !== "" && customer.vc_CurrencySymbol !== "undefined")
            ? customer.vc_CurrencySymbol
            : BaseCurrency;
        const ConversionRate = await convertCurrency(BaseCurrency, newCurrencySymbol, currencyList, "0");

        setCurrencyCustomerSymbol1(newCurrencySymbol);
        // fetchParts(customer.ClientCompanyID);
        setConRate(ConversionRate);


        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const CustomerStock = await fetchCustomerStock(customer.ClientCompanyID);
        if (CustomerStock.length > 0) {
            setCustomerCategoryType(CustomerStock[0].FK_DiscountType_ID);
            setCustomerCategoryTax(CustomerStock[0].dec_Amount);

            const StockCategryList = await StockDiscountCategoryService.GetStockByCategoryID(redirectCallback, CustomerStock[0].FK_StockCategory_ID);
            setCustomerStockList(StockCategryList);
            // Level 3 Discount
            let QuantityBreakDiscount = await fetchCustomerCategoryDiscount(CustomerStock[0].FK_StockCategory_ID);
            setQuantityBreak(QuantityBreakDiscount);
        }
        //End Level 2 Discount

        //Level 3 Discount
        setVatTax(customer.dec_Rate);
        setCustomerTax(customer.dec_Amount ?? 0.00);
        setCustomertaxType(customer.FK_DiscountType_ID ?? 0);
        setFormData({
            ...formData,
            CustomerID: customer.ClientCompanyID,
            CustomerName: customer.CompanyName,
            AccountRef: customer.AccountRef,
            FK_ClientBranch_ID: 0,
            FK_ClientContact_ID: 0,
            dec_CurrencyToBaseRate: ConversionRate
        });
        if (InvoiceID > 0) {
            await fetchQuotationItems(newCurrencySymbol, ConversionRate);
        }
        else {

            const selectedPartsData = await Promise.all(selectedParts.map(async (detail) => {
                const convertedStockPrice = (detail.mon_StockPrice * ConversionRate);
                const convertedmon_SalesPrice = (detail.mon_SalesPrice * ConversionRate);
                const convertednet_SalesPrice = (detail.net_SalesPrice * ConversionRate);
                const converteddetailnet_VATPrice = (detail.net_VATPrice * ConversionRate);
                const convertedmon_SellingPrice = (detail.mon_SellingPrice * ConversionRate);
                return {
                    vc_StockCode: detail.vc_StockCode,
                    vc_Description: detail.vc_Description,
                    mon_StockPrice: parseFloat(convertedStockPrice).toFixed(2), // Use the converted price
                    mon_SalesPrice: parseFloat(convertedmon_SalesPrice).toFixed(2),
                    dec_Quantity: detail.dec_Quantity,
                    net_SalesPrice: parseFloat(convertednet_SalesPrice).toFixed(2),
                    net_VATPrice: parseFloat(converteddetailnet_VATPrice).toFixed(2),
                    vc_StockName: detail.vc_Description,
                    PK_Stock_ID: detail.FK_Stock_ID,
                    dec_Discount: detail.dec_Discount,
                    mon_SellingPrice: parseFloat(convertedmon_SellingPrice).toFixed(2),
                    StockType: detail.StockType || 0,
                    IsAlreadyShipped: detail.IsAlreadyShipped || 0
                    // Map other fields as needed
                };
            }));
            setSelectedParts(selectedPartsData);
        }

        fetchCustomerContact(customer.ClientCompanyID);
        fetchCustomersSites(customer.ClientCompanyID);
        setShowCustomerModal(false);
    };

    const handlePartSelect = async (selectedPartsArray) => {
        const targetCurrency = currencyCustomerSymbol1 || BaseCurrency;
        setIsChanged(true);
        const ConversionRate = await convertCurrency(
            BaseCurrency,
            targetCurrency,
            currencyList,
            "0"
        );

        const convertedParts = await Promise.all(
            selectedPartsArray.map(async (part) => {

                const convertedStockPrice = part.mon_StockPrice * ConversionRate;
                const convertedmon_SalesPrice = part.mon_SalesPrice * ConversionRate;
                const convertednet_SalesPrice = part.net_SalesPrice * ConversionRate;
                const converteddetailnet_VATPrice = part.net_VATPrice * ConversionRate;
                const convertedmon_SellingPrice = part.mon_SellingPrice * ConversionRate;
                const redirectCallback = () => {
                    navigate('/'); // Redirect to the login page
                };
                // FIX: use part.PK_Stock_ID instead of undefined PartID
                const listOfLocations = await PartService.GetPartLocation(
                    redirectCallback,
                    part.PK_Stock_ID
                );
                debugger;
                let PK_StockLocation_ID = "0";
                let DepotQuantity = "0";
                let vc_Name = "";
                if (listOfLocations.length === 1) {

                    PK_StockLocation_ID = listOfLocations[0].PK_StockLocation_ID;
                    DepotQuantity = listOfLocations[0].dec_Quantity;
                    vc_Name = listOfLocations[0].vc_Name;

                }

                return {
                    ...part,
                    mon_StockPrice: convertedStockPrice,
                    mon_SalesPrice: convertedmon_SalesPrice,
                    mon_SellingPrice: convertedmon_SellingPrice, // FIX: was wrong variable
                    dec_Discount: calculateDiscountAmount(
                        convertedmon_SalesPrice,
                        formData.dec_DiscountAmount,
                        formData.int_DiscountType,
                        part.vc_UnitOfSale,
                        formData.dec_DiscountAmount,
                        part.PK_Stock_ID
                    ),
                    net_SalesPrice: calculateNetSalesPrice(
                        convertedmon_SalesPrice,
                        formData.dec_DiscountAmount,
                        formData.int_DiscountType,
                        part.vc_UnitOfSale,
                        formData.dec_DiscountAmount,
                        part.PK_Stock_ID
                    ),
                    net_VATPrice: calculateDiscountPrice(
                        parseFloat(convertedmon_SalesPrice || 0),
                        formData.dec_DiscountAmount,
                        formData.int_DiscountType,
                        part.vc_UnitOfSale,
                        formData.dec_DiscountAmount,
                        part.PK_Stock_ID
                    ),
                    PK_StockLocation_ID: PK_StockLocation_ID,
                    DepotQuantity: DepotQuantity,
                    vc_Name: vc_Name
                };
            })
        );

        setSelectedParts(prev => [...prev, ...convertedParts]);
        setShowPartModal(false);
    };

    const fetchQuotationItems = async (newCurrencySymbol, ConversionRate) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            if (InvoiceID > 0) {
                const saleOrderDetails = await InvoiceService.GetInvoiceItem(redirectCallback, InvoiceID);

                const selectedPartsData = await Promise.all(saleOrderDetails.map(async (detail) => {
                    const convertedStockPrice = (detail.mon_StockPrice * ConversionRate)
                    const convertedmon_SalesPrice = (detail.mon_SalesPrice * ConversionRate);
                    const converteddec_Quantity = (detail.dec_Quantity * ConversionRate);
                    const convertednet_SalesPrice = (detail.net_SalesPrice * ConversionRate);
                    const converteddetailnet_VATPrice = (detail.net_VATPrice * ConversionRate);
                    const convertedmon_SellingPrice = (detail.mon_SellingPrice * ConversionRate);

                    return {
                        FK_Invoice_ID: detail.FK_Invoice_ID,
                        FK_Stock_ID: detail.FK_Stock_ID,
                        PK_InvoiceItem_ID: detail.PK_InvoiceItem_ID,
                        DepotName: detail.DepotName,
                        FK_Location_ID_Stock: detail.FK_Location_ID_Stock,
                        vc_StockCode: detail.vc_StockCode,
                        vc_Description: detail.vc_Description,
                        mon_StockPrice: parseFloat(convertedStockPrice).toFixed(2), // Use the converted price
                        mon_SalesPrice: parseFloat(convertedmon_SalesPrice).toFixed(2),
                        dec_Quantity: detail.dec_Quantity,
                        vc_UnitOfSale: detail.vc_UnitOfSale,
                        net_SalesPrice: parseFloat(convertednet_SalesPrice).toFixed(2),
                        net_VATPrice: parseFloat(converteddetailnet_VATPrice).toFixed(2),
                        vc_StockName: detail.vc_Description,
                        PK_Stock_ID: detail.FK_Stock_ID,
                        dec_Discount: detail.dec_Discount,
                        mon_SellingPrice: parseFloat(convertedmon_SellingPrice).toFixed(2),
                        dec_QtyAllocated: detail.dec_QtyAllocated,
                        dec_QuantityShipped: detail.dec_QuantityShipped,
                        PK_StockLocation_ID: detail.PK_StockLocation_ID,
                        vc_Name: detail.DepotName,
                        DepotQuantity: detail.DepotQuantity || 0,
                        StockType: detail.StockType || 0,
                        IsAlreadyShipped: detail.IsAlreadyShipped || 0
                        // Map other fields as needed
                    };
                }));
                debugger;
                setSelectedParts(selectedPartsData);
            }
        } catch (error) {
            console.error('Error fetching supplier details:', error);
        }
    };
    const resetForm = () => {

        setFormData({
            CustomerID: 0,
            CustomerName: '',
            FK_ClientBranch_ID: 0,
            FK_ClientContact_ID: 0,
            AccountRef: "",
            vc_CustomerOrderNumber: "",
            dt_InvoiceDate: getCurrentDate(),
            dt_DueDate: getCurrentDate(),
            PaymentTermID: "1",
            FK_QuotationStatus_ID: 0,
            FK_Issue_ID: 0,
            vc_User5: "",
            int_DiscountType: 0,
            dec_DiscountAmount: "0",
            dec_DiscountNETTotal: "0.00",
            mon_TotalPrice: "",
            mon_TotalPriceO: "",
            mon_TotalPriceG: "",
            mon_TotalPriceGR: "",
            FK_InvoiceType_ID: "1",
            ClientType: "0",
            ClientCompanyName: "",
            Forename: "",
            Address1: "",
            Surname: ""
        });
    };
    const removeRow = (index) => {

        const updatedTableData = [...selectedParts];
        updatedTableData.splice(index, 1);
        setSelectedParts(updatedTableData);
    };
    const handleAddRow = () => {
        const newRow = {
            PK_Stock_ID: 0,
            vc_StockCode: "S1",            // Default Product Code
            vc_Description: "Free Text",            // Default Description (Free text)
            mon_SalesPrice: "0.00",        // Default Sale Price
            vc_UnitOfSale: "0.00",
            dec_Discount: "0.00",
            net_SalesPrice: "0.00",
            net_VATPrice: "0.00",
            mon_StockPrice: "0.00",
            dec_Quantity: "0",
            mon_SellingPrice: "0.00",
            isNew: true  // This will help identify newly added rows
        };
        setSelectedParts([...selectedParts, newRow]);
    };

    const GetInvoiceDetail = async (InvoiceID) => {
        try {
            const redirectCallback = () => navigate('/');
            if (InvoiceID > 0) {
                const saleOrderDetail = await InvoiceService.GetInvoiceByID(redirectCallback, InvoiceID);
                const saleOrder = saleOrderDetail[0];
                return saleOrder;
            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };
    const fetchInvoiceItemHistory = async (InvoiceItemID) => {
        try {
            setInvoiceItemHistory([]);
            setShowInvoiceHistoryModal(true);
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const list = await InvoiceService.GetInvoiceItemHistory(redirectCallback, InvoiceItemID);
            setInvoiceItemHistory(list);
        } catch (error) {
            console.error('Error fetching locations:', error);
        }
    };
    const fetchStockLocations = async (PartID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const listOfLocations = await PartService.GetPartLocation(redirectCallback, PartID);
            setStockLocationList(listOfLocations);
            setActivePartId(PartID); // Set the current part ID for which locations are being loaded
            return listOfLocations;
        } catch (error) {
            console.error('Error fetching locations:', error);
        }
    };
    const handleAllocateInvoice = async (event, part, index) => {

        event.stopPropagation();
        const listOfLocations = await fetchStockLocations(part.FK_Stock_ID);
        if (listOfLocations.length > 0) {
            setIsSidebarOpen(true);
            // Include the part object with each location
            const locationsWithPart = listOfLocations.map(location => ({ ...location, part }));
            setStockLocation(locationsWithPart);

            // Fix: Modify part directly if it's an object, or handle part array separately
            part.FK_Location_ID_Stock = listOfLocations[0].PK_StockLocation_ID;

            // Uncomment if this is needed
            // onSelectPart(part);
        } else {
            part.FK_Location_ID_Stock = 0;
            setStockLocation([]);
            // onSelectPart(part);
        }
    }
    const onCloseDepots = () => {
        setIsSidebarOpen(false);
        setStockLocation([]); // Optional: Clear stock locations on close
    };
    const truncateText = (text, maxLength = 15) => {
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    const truncateTextPdf = (text, maxLength = 25) => {
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    const handleLocationClick = async (part, depot, index) => { // Ensure index is passed if needed

        part.LocationID = depot.PK_StockLocation_ID;
        part.DepotName = depot.vc_Name;
        part.DepotQuantity = (depot.dec_Quantity - depot.dec_Allocated);
        const InvoiceDetail = await GetInvoiceDetail(part.FK_Invoice_ID);
        let snt_AllocatedStatus = 1;
        const total = parseFloat(part.DepotQuantity) + parseFloat(part.dec_QtyAllocated);
        if (Math.round(parseFloat(total)) < Math.round(parseFloat(part.vc_UnitOfSale))) {
            snt_AllocatedStatus = 2;
        }

        const formData = {
            PK_Invoice_ID: InvoiceDetail.PK_Invoice_ID,
            snt_AllocatedStatus: snt_AllocatedStatus
        };

        const formDataWithParts = {
            formData: formData,
            selectedParts: part
        };

        const postData = await InvoiceService.AllocateInvoice(formDataWithParts);
        // const updatedPart = { ...part };

        // Ensure updatedParts is an array
        // const updatedParts = [...selectedParts]; // or wherever updatedParts is stored
        // updatedParts[index] = updatedPart; // Ensure index exists or is passed correctly

        // setSelectedParts([...updatedParts]); // Update state with new parts list
        setIsSidebarOpen(false);
    }
    useEffect(() => {
        // Load image as base64
        const loadImage = async () => {
            try {
                const ClientID = localStorage.getItem('CompanyID');
                const redirectCallback = () => {
                    navigate('/'); // Redirect to the login page
                };

                const companySetup = await CompanySetupController.GetCompanyByID(redirectCallback, ClientID);
                const fileName = companySetup[0]?.FileName; // Check if fileName exists

                let imageUrl;
                if (!fileName) {
                    // Use fallback image if fileName is null or empty
                    imageUrl = 'assets/img/resources/trent.PNG';
                } else {
                    imageUrl = `${BASE_URL}/uploads/${ClientID}/Admin/CompanySetup/${fileName}`;
                }
                debugger;
                console.log("Fetching image from:", imageUrl); // Debugging

                const response = await fetch(imageUrl, {
                    method: 'GET',
                    mode: 'cors', // Ensure CORS mode
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    console.error(`Error fetching image: ${response.statusText}`);
                    return;
                }

                const blob = await response.blob();
                const reader = new FileReader();
                reader.onloadend = () => {
                    setImageData(reader.result); // Convert to base64
                };
                reader.readAsDataURL(blob);
            } catch (error) {
                console.error("Error loading image:", error);
            }
        };

        loadImage();
    }, []);

    const generatePDF = async (event) => {
        event.stopPropagation();

        try {
            const result = await Swal.fire({
                title: "Include Terms & Conditions?",
                text: "Do you want to include Terms & Conditions in the print?",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Yes, include it",
                cancelButtonText: "No, just main report",
            });

            const includeTerms = result.isConfirmed;

            const blob = await getMergedPDFBlob(includeTerms);

            const finalUrl = URL.createObjectURL(blob);

            setPdfUrl(finalUrl);
            setShowPdfModal(true);

            localStorage.setItem('HasRecordUpdated', "1");

        } catch (err) {
            console.error(err);
        }
    };
    const generatePDFForEmail = async (termsFlag) => {
        try {
            setLoading(true);

            const blob = await getMergedPDFBlob(termsFlag);

            const file = new File([blob], 'Invoice.pdf', {
                type: 'application/pdf'
            });

            setPdfAttachment(file);
            setIsEmailModalOpen(true);

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const getMergedPDFBlob = async (includeTerms = true) => {

        try {

            const currentInputValues = {
                ClientID: localStorage.getItem("CompanyID"),
                ID: InvoiceID
            };

            const redirectCallback = () => {
                navigate('/');
            };

            // ================= MAIN REPORT =================

            let reportData = await ReportService.GetCompanyReports(
                redirectCallback,
                "22"
            );

            reportData = reportData.filter(
                x => x.IsDefault.toString() === "1"
            );

            const reportID =
                reportData.length > 0
                    ? reportData[0].ID
                    : 111;

            const JasperReport =
                await JasperReportService.GetJasperReportByID(reportID);

            let url = JasperReport[0].Link;

            setReportLink(url);

            setReportTitle(JasperReport[0].ReportTitle);

            // replace placeholders in main report
            Object.keys(currentInputValues).forEach((key) => {

                const placeholder = new RegExp(`{${key}}`, 'g');

                let value = currentInputValues[key];

                if (key === "ClientID") {

                    value = localStorage.getItem("CompanyID");

                } else if (key === "UserID") {

                    value = localStorage.getItem("UserID");

                }

                if (url.includes(`{${key}}`)) {

                    url = url.replace(placeholder, value);

                }

            });

            const queryObjMain = {
                ...currentInputValues,
                format: 'pdf',
                ReportName: JasperReport[0].ReportName,
                ReportType: JasperReport[0].ReportType,
                name: JasperReport[0].ReportName
            };

            const queryStringMain =
                new URLSearchParams(queryObjMain).toString();

            const responseMain = await axiosInstance.get(
                `/Dashboard/ProxyReport?${queryStringMain}`,
                { responseType: 'blob' }
            );

            const mainPdfBytes =
                await responseMain.data.arrayBuffer();

            // ================= MERGE PDFs =================

            const mergedPdf = await PDFDocument.create();

            const mainPdf =
                await PDFDocument.load(mainPdfBytes);

            const mainPages =
                await mergedPdf.copyPages(
                    mainPdf,
                    mainPdf.getPageIndices()
                );

            mainPages.forEach((page) =>
                mergedPdf.addPage(page)
            );

            // ================= TERMS PDF =================

            if (includeTerms) {

                const companySetup =
                    await CompanySetupController.GetCompanyByID(
                        redirectCallback,
                        localStorage.getItem("CompanyID")
                    );

                const termFile =
                    companySetup?.[0]?.TermFile;

                // Only attach second PDF if file exists
                if (termFile) {

                    const ClientID =
                        localStorage.getItem('CompanyID');

                    const FileUrl =
                        `${BASE_URL}/uploads/${ClientID}/Admin/TermConditions/${termFile}`;

                    const responseSecond =
                        await axiosInstance.get(
                            FileUrl,
                            { responseType: 'blob' }
                        );

                    const secondPdfBytes =
                        await responseSecond.data.arrayBuffer();

                    const secondPdf =
                        await PDFDocument.load(secondPdfBytes);

                    const secondPages =
                        await mergedPdf.copyPages(
                            secondPdf,
                            secondPdf.getPageIndices()
                        );

                    secondPages.forEach((page) =>
                        mergedPdf.addPage(page)
                    );
                }
            }

            const mergedPdfBytes =
                await mergedPdf.save();

            return new Blob(
                [mergedPdfBytes],
                { type: "application/pdf" }
            );

        } catch (err) {

            console.error("Error executing report:", err);

            setError("Failed to execute the report.");

            return null;
        }
    };




    const handleCloseEmailModal = async () => {
        setIsEmailModalOpen(false);
    };
    const handleSuccess = async () => {
        setShowShippedModal(false);
        await fetchInvoiceDetail();
    };
    const { handleShipInvoice } = ShipInvoice(InvoiceID);
    const InvoiceAllocation = async (event, part, index) => {
        event.stopPropagation();
        if (InvoiceID > 0) {
            const invoiceDetail = await fetchInvoice(InvoiceID);
            if (invoiceDetail.snt_AllocatedStatus === 2) {
                Swal.fire(
                    '',
                    'The Selected Invoice is already allocated',
                    'Warning'
                );
            }
            else {
                if (invoiceDetail.ContractInvoice > 0) {
                    Swal.fire(
                        '',
                        'The Selected invoice can not be shipped as this order is generated from the Agreement',
                        'Warning'
                    );
                }
                else {
                    if (invoiceDetail.bit_DropShipment === 2 || invoiceDetail.snt_AllocatedStatus === 2) {
                        Swal.fire(
                            '',
                            'The Selected invoice is already allocated or shipped',
                            'Warning'
                        );
                    }
                    else {
                        Swal.fire({
                            title: 'Are you sure?',
                            text: "You won't be able to revert this!",
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Yes, allocate it!'
                        }).then(async (result) => {
                            if (result.isConfirmed) {
                                try {

                                    setInvoiceItems([]);
                                    setShowShippedModal(true);
                                    debugger;
                                    set_bnt_OrderNumber(invoiceDetail.bnt_OrderNumber);
                                    const InvoiceItemList = await handleShipInvoice(event, InvoiceID);
                                    debugger;
                                    setShowShippedModal(InvoiceItemList);


                                } catch (error) {

                                }
                            }
                        });
                    }
                }
            }
        }
        else {
            Swal.fire(
                'Error!',
                'Please check at least one record to delete invoice.',
                'warning'
            );
        }


    }
    const handleShippment = async (event, part, index) => {
        event.stopPropagation();
        if (InvoiceID > 0) {
            const invoiceDetail = await fetchInvoice(InvoiceID);

            if (invoiceDetail.bit_DropShipment === 2) {
                Swal.fire(
                    '',
                    'The Selected invoice is already shipped',
                    'Warning'
                );
            }
            else {
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, post it!'
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        try {
                            setInvoiceItems([]);
                            // setShowShippedModal(true);
                            set_bnt_OrderNumber(invoiceDetail.bnt_OrderNumber);
                            const InvoiceItemList = await handleShipInvoice(event, InvoiceID);

                            if (!InvoiceItemList) {
                                // If depot issue detected, stop submission
                                return;
                            }

                            const formDataWithParts = {
                                formData: formData,
                                selectedParts: InvoiceItemList,
                            };

                            const postData = await InvoiceService.ShipInvoice(formDataWithParts);
                            if (postData.message === "Data saved successfully") {
                                localStorage.setItem('HasRecordUpdated', "1");
                                Swal.fire(
                                    '',
                                    'The Invoice posted successfully.',
                                    'success'
                                );
                                handleSuccess();
                            }
                        } catch (error) {

                        }
                    }

                });

            }

        }
        else {
            Swal.fire(
                'Error!',
                'Please check at least one record to delete invoice.',
                'warning'
            );
        }
    }

    const handleUnAllocate = async (event, part, index) => {
        event.stopPropagation();
        if (InvoiceID > 0) {
            const saleOrderDetail = await fetchInvoice(InvoiceID);
            if (saleOrderDetail.snt_AllocatedStatus === 0 || saleOrderDetail.snt_AllocatedStatus === null) {
                Swal.fire(
                    '',
                    'The selected invoice is not allocated.',
                    'Warning'
                );
            }
            else {
                if (saleOrderDetail.bit_DropShipment === 2) {
                    Swal.fire(
                        '',
                        'The Selected invoice is already shipped',
                        'Warning'
                    );
                }
                else {
                    Swal.fire({
                        title: 'Are you sure?',
                        text: "You won't be able to unallocate this!",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes!'
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            try {
                                const postData = await InvoiceService.UnAllocateInvoice(InvoiceID);
                                if (postData.message === "Data saved successfully") {
                                    localStorage.setItem('HasRecordUpdated', "1");
                                    Swal.fire(
                                        '',
                                        'The invoice unallocated successfully.',
                                        'success'
                                    );
                                    handleSuccess();
                                }
                            } catch (error) {

                            }
                        }

                    });
                }
            }

        }
        else {
            Swal.fire(
                'Error!',
                'Please check at least one record to delete invoice.',
                'warning'
            );
        }
    }

    const handleCloseShippmentModal = () => {

        fetchInvoiceDetail();
        setShowShippedModal(false);
    };

    const CompanyID = localStorage.getItem("CompanyID");
    const fetchAssignedModules = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const modules = await ModuleService.GetCompanyModules(redirectCallback, "en", CompanyID);
            const moduleSet = new Set(modules.map(m => m.PK_SearchModule_ID)); // Store assigned module IDs in a Set
            setAssignedModules(moduleSet);
        } catch (error) {
            console.error('Error fetching assigned modules:', error);
        }
    };


    const handleDepotSelect = (depot) => {

        debugger;

        // ✅ find part using InvoiceItemID OR StockID
        const selectedPart = selectedParts.find(p =>
            (saleItemID > 0 && p.PK_InvoiceItem_ID === saleItemID)
            ||
            (saleItemID <= 0 && p.PK_Stock_ID === activePartId)
        );

        if (!selectedPart) return;

        const requiredQty = parseFloat(selectedPart.vc_UnitOfSale || 0);
        const availableQty = parseFloat(depot.dec_Quantity || 0);

        setSelectedDepot(prev => ({
            ...prev,
            [saleItemID > 0 ? saleItemID : activePartId]: {
                PK_StockLocation_ID: depot.PK_StockLocation_ID,
                vc_Name: depot.vc_Name,
                DepotQuantity: depot.dec_Quantity
            }
        }));

        // ✅ update ONLY selected row
        const updatedParts = selectedParts.map(part => {

            const isMatch =
                (saleItemID > 0 && part.PK_InvoiceItem_ID === saleItemID)
                ||
                (saleItemID <= 0 && part.PK_Stock_ID === activePartId);

            if (isMatch) {
                return {
                    ...part,
                    PK_StockLocation_ID: depot.PK_StockLocation_ID,
                    vc_Name: depot.vc_Name,
                    DepotQuantity: depot.dec_Quantity,
                    FK_Location_ID_Stock: depot.PK_StockLocation_ID
                };
            }

            return part;
        });

        setSelectedParts(updatedParts);
        setShowDepotModal(false);
    };
    const openDepotModal = (partId, invoiceItemID) => {

        setActivePartId(partId);

        // use fallback if null
        setSaleItemID(invoiceItemID || 0);

        fetchStockLocations(partId);
        setShowDepotModal(true);
    };
    const handleRadioChange = (event) => {
        const { value } = event.target;

        // Create a base object with `type` updated
        let updatedFormData = {
            ...formData,
            ClientType: value
        };

        // Extend `updatedFormData` with additional fields based on the selected value
        if (value === "1") {
            // setCustomerModal(true);
        } else if (value === "2") {
            // setLeadModal(true);
        } else if (value === "2") {
            // setOpportunityModal(true);
        }

        // Update the formData state with the final object
        setFormData(updatedFormData);
    };
    return (
        <div>

            {isSidebarOpen && (

                <div className={`right-sidebar-depot ${isSidebarOpen ? 'open' : ''}`}>
                    <table className="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>
                        <thead style={{ "background": "rgb(77, 138, 192)" }}>
                            <tr>
                                <th style={{ "width": "90%" }}>New/Existing Depots</th>
                                <th>
                                    <button type="button" className="close" aria-label="Close" onClick={onCloseDepots}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </th>
                            </tr>
                        </thead>
                    </table>
                    <div className="tab-pane fade show active">
                        <div className="row mb-3" style={{ "marginLeft": "0px", "marginRight": "0px" }}>
                            <table className="table m-0 table-hover" style={{ "width": "90%", "marginLeft": "10px", "border": "1px solid #dee2e6" }}>
                                <tbody>

                                    {StockLocationList.map((record) => (
                                        <tr key={record.PK_StockLocation_ID} onClick={() => handleLocationClick(record.part, record)} style={{ "cursor": "pointer" }}>
                                            <td className="no-wrap">{truncateText(record.vc_Name)}</td>
                                            <td className="no-wrap">{truncateText(record.vc_BayName)}</td>
                                            <td className="no-wrap">{(record.dec_Quantity) - (record.dec_Allocated)}</td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}







            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}

            <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                <div className="col-xl-12" style={{ "textAlign": "right" }}>

                </div>
            </div>

            <form onSubmit={handleFormSubmit} style={{
                // IE/Edge
            }}>
                <div

                >
                    <table style={{ width: "100%" }}>
                        <tbody>

                            {formData.ClientType?.toString() === "0" && (
                                <>
                                    <tr>
                                        <td style={{ width: "13%" }}><label htmlFor="CustomerID" style={{ float: "right" }}>Company <span style={{ "color": "red" }}>*</span></label></td>
                                        <td style={{ width: "37%" }}>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="CustomerID"
                                                name="CustomerID"
                                                value={formData.CustomerName}
                                                onClick={() => setShowCustomerModal(true)}
                                                readOnly
                                                disabled={isClosed === '1' || isClosed === 1}
                                            />
                                            {errors.CustomerID && <div style={{ color: 'red' }}>{errors.CustomerID}</div>}
                                        </td>

                                        <td style={{ width: "14%" }}><label htmlFor="vc_SerialNumber" style={{ float: "right" }}>Site <span style={{ "color": "red" }}>*</span></label></td>
                                        <td style={{ width: "36%" }}>
                                            <select name="FK_ClientBranch_ID" className='form-control' value={formData.FK_ClientBranch_ID} onChange={handleBranchChange} disabled={isClosed === '1' || isClosed === 1}>
                                                <option value="0">Select Site</option>
                                                {CustomerSiteList.map((site) => (
                                                    <option key={site.ClientBranchID} value={site.ClientBranchID}>
                                                        {site.BranchName}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.FK_ClientBranch_ID && <div style={{ color: 'red' }}>{errors.FK_ClientBranch_ID}</div>}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><label htmlFor="FK_ClientContact_ID" style={{ float: "right" }}>Contact <span style={{ "color": "red" }}>*</span></label></td>
                                        <td>
                                            <select name="FK_ClientContact_ID" className='form-control' value={formData.FK_ClientContact_ID} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1}>
                                                <option value="0">Select Contact</option>
                                                {CustomerContactList.map((contact) => (
                                                    <option key={contact.ClientContactID} value={contact.ClientContactID}>
                                                        {contact.Title} {contact.FirstName} {contact.SurName}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.FK_ClientContact_ID && <div style={{ color: 'red' }}>{errors.FK_ClientContact_ID}</div>}
                                        </td>
                                        <td><label htmlFor="AccountRef" style={{ float: "right" }}>Account Ref &nbsp;&nbsp;</label></td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="AccountRef"
                                                name="AccountRef"
                                                value={formData.AccountRef}
                                                onChange={(e) => setFormData({ ...formData, AccountRef: e.target.value })}
                                                readOnly
                                                disabled={isClosed === '1' || isClosed === 1}
                                            />
                                        </td>
                                    </tr>
                                </>
                            )}
                            {formData.ClientType?.toString() === "1" && (
                                <>
                                    <tr>
                                        <td>
                                            <label htmlFor="ClientCompanyName" style={{ float: "right" }}>Company <span style={{ "color": "red" }}>*</span></label>
                                        </td>
                                        <td>
                                            <input type="text" className="form-control" name="ClientCompanyName" value={formData.ClientCompanyName} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                            {errors.ClientCompanyName && <div style={{ color: 'red' }}>{errors.ClientCompanyName}</div>}
                                        </td>
                                        <td>
                                            <label htmlFor="Forename" style={{ float: "right" }}>Forename <span style={{ "color": "red" }}>*</span></label>
                                        </td>
                                        <td>
                                            <input type="text" className="form-control" name="Forename" value={formData.Forename} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                            {errors.Forename && <div style={{ color: 'red' }}>{errors.Forename}</div>}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label htmlFor="Address1" style={{ float: "right" }}>Address <span style={{ "color": "red" }}>*</span></label>
                                        </td>
                                        <td>
                                            <input type="text" className="form-control" name="Address1" value={formData.Address1} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                            {errors.Address1 && <div style={{ color: 'red' }}>{errors.Address1}</div>}
                                        </td>
                                        <td>
                                            <label htmlFor="dt_QuotationDate" style={{ float: "right" }}>Surname <span style={{ "color": "red" }}>*</span></label>
                                        </td>
                                        <td>
                                            <input type="text" className="form-control" name="Surname" value={formData.Surname} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                            {errors.Surname && <div style={{ color: 'red' }}>{errors.Surname}</div>}
                                        </td>
                                    </tr>
                                </>

                            )}

                            <tr>

                                <td><label htmlFor="dt_InvoiceDate" style={{ float: "right" }}>Invoiced Date &nbsp;&nbsp;</label></td>
                                <td>
                                    <input type="date" className="form-control" name="dt_InvoiceDate" value={formData.dt_InvoiceDate} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                    {errors.dt_InvoiceDate && <div style={{ color: 'red' }}>{errors.dt_InvoiceDate}</div>}
                                </td>
                                <td><label htmlFor="dt_DueDate" style={{ float: "right" }}>Due Date &nbsp;&nbsp;</label></td>
                                <td>

                                    <input type="date" className="form-control" name="dt_DueDate" value={formData.dt_DueDate} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                    {errors.dt_DueDate && <div style={{ color: 'red' }}>{errors.dt_DueDate}</div>}
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <label htmlFor="vc_CustomerOrderNumber" style={{ float: "right" }}>Customer Order No &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <input type="text" className="form-control" name="vc_CustomerOrderNumber" value={formData.vc_CustomerOrderNumber} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                    {errors.vc_CustomerOrderNumber && <div style={{ color: 'red' }}>{errors.vc_CustomerOrderNumber}</div>}
                                </td>
                                <td><label htmlFor="FK_ClientContact_ID" style={{ float: "right" }}>Payment Term &nbsp;&nbsp;</label></td>
                                <td>
                                    <select name="PaymentTermID" className='form-control' value={formData.PaymentTermID} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1}>
                                        <option value="0">Payment Term</option>
                                        {PaymentTermList.map((payment) => (
                                            <option key={payment.ID} value={payment.ID}>
                                                {payment.PaymentType}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.PaymentTermID && <div style={{ color: 'red' }}>{errors.PaymentTermID}</div>}
                                </td>

                            </tr>
                            {KeyNameList.length > 0 && (
                                <>
                                    <LeadUserDefineFieldsSection
                                        KeyNameList={KeyNameList}
                                        formData={formData}
                                        errors={errors}
                                        handleInputChange={handleFieldChange}
                                        handleDecimalChange={handleDecimalChange}
                                        handleIntegerChange={handleIntegerChange}
                                        handleFileChange={handleFileChange}
                                    />
                                </>
                            )}
                        </tbody>
                    </table>
                    <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                        <div className='col-sm-12' >
                            <table className="table datatable table-bordered">
                                <thead>
                                    <tr>
                                        <th className="no-wrap" style={{ "width": "10%" }}>Prod..</th>
                                        <th className="no-wrap" style={{ "width": "12%" }}>Desc...</th>
                                        <th className="no-wrap" style={{ "width": "10%" }}>Sales Price</th>
                                        <th className="no-wrap" style={{ "width": "10%" }}>Selling Price</th>

                                        <th className="no-wrap" style={{ "width": "10%" }}>Depot</th>

                                        <th className="no-wrap" style={{ "width": "10%" }}>Quantity</th>
                                        <th className="no-wrap" style={{ "width": "10%" }}>Discount</th>
                                        <th className="no-wrap" style={{ "width": "10%" }}>Net</th>
                                        <th className="no-wrap" style={{ "width": "10%" }}>VAT</th>
                                        <th className="no-wrap" style={{ "width": "8%" }}>Actions</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>

                        <div className='col-sm-12' style={{ "overflow-y": "auto", "maxHeight": "150px" }}>
                            <table className="table datatable table-bordered">
                                <tbody>
                                    {selectedParts.map((part, index) => (
                                        <tr key={index}>
                                            <td className="no-wrap" style={{ "width": "10%" }}>

                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={part.vc_StockCode}
                                                    readOnly="true"
                                                    onChange={(e) => handlePartChange(e, index, 'vc_StockCode')}
                                                    disabled={isClosed === '1' || isClosed === 1}
                                                />
                                            </td>
                                            <td className="no-wrap" style={{ "width": "12%" }}>
                                                <div
                                                    onMouseEnter={(e) => {
                                                        const rect = e.target.getBoundingClientRect();
                                                        setModalPosition({ top: rect.top + window.scrollY - 50, left: rect.left });
                                                        setDescriptionText(part.vc_Description);
                                                        setShowDescriptionModal(true);
                                                    }}
                                                    onMouseLeave={() => setShowDescriptionModal(false)}
                                                >
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={part.vc_Description}
                                                        onChange={(e) => {
                                                            const updatedPart = { ...part, vc_Description: e.target.value };
                                                            const updatedParts = [...selectedParts];
                                                            updatedParts[index] = updatedPart;
                                                            setSelectedParts(updatedParts);
                                                        }}
                                                        disabled={isClosed === '1' || isClosed === 1}
                                                    />
                                                </div>
                                            </td>
                                            <td className="no-wrap" style={{ "width": "10%" }}>
                                                <CurrencyTextField
                                                    initialCurrencySymbol={currencyCustomerSymbol1}
                                                    initialCurrencyValue={part.mon_SellingPrice}
                                                    currencyList={currencyList}
                                                    onCurrencyChange={(newValue) => {
                                                        const updatedPart = { ...part, mon_SellingPrice: newValue };
                                                        const updatedParts = [...selectedParts];
                                                        updatedParts[index] = updatedPart;
                                                        setSelectedParts(updatedParts);
                                                    }}
                                                    disabled={true}
                                                />
                                            </td>
                                            <td className="no-wrap" style={{ "width": "10%" }}>
                                                <CurrencyTextField initialCurrencySymbol={currencyCustomerSymbol1} initialCurrencyValue={part.mon_SalesPrice}
                                                    currencyList={currencyList}
                                                    onCurrencyChange={(newValue) => handleSalesPriceChange(index, newValue, 'mon_SalesPrice')} />
                                            </td>
                                            <td className="no-wrap" style={{ width: "10%" }}>
                                                {part.PK_Stock_ID > 0 && part.StockType?.toString() === "1" && (
                                                    <div className="depot-selection">

                                                        <span
                                                            className="selected-depot"
                                                            onClick={() => openDepotModal(part.PK_Stock_ID, part.PK_InvoiceItem_ID)}
                                                            style={{
                                                                cursor: 'pointer',
                                                                color: 'blue',
                                                                textDecoration: 'underline'
                                                            }}
                                                        >

                                                            {
                                                                // ✅ FIRST priority → show depot from part itself (auto-assigned case)
                                                                part.vc_Name && part.PK_StockLocation_ID > 0

                                                                    ? part.vc_Name

                                                                    // ✅ SECOND priority → show depot selected manually
                                                                    : selectedDepot[part.PK_InvoiceItem_ID || part.PK_Stock_ID]?.vc_Name

                                                                    // ✅ otherwise show default text
                                                                    || 'Select Depot'
                                                            }

                                                        </span>

                                                    </div>
                                                )}
                                            </td>
                                            <td className="no-wrap" style={{ "width": "10%" }}>

                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={part.vc_UnitOfSale}
                                                    onChange={(e) => handleQuantityChange(index, e.target.value)}
                                                    disabled={part.IsAlreadyShipped > 0 && part.FK_Stock_ID > 0 && part.StockType > 0}

                                                />
                                            </td>

                                            <td className="no-wrap" style={{ "width": "10%" }}>

                                                <CurrencyTextField
                                                    initialCurrencySymbol={currencyCustomerSymbol1}
                                                    initialCurrencyValue={part.dec_Discount}
                                                    currencyList={currencyList}
                                                    disabled={true}
                                                />
                                            </td>






                                            <td className="no-wrap" style={{ "width": "10%" }}>
                                                <CurrencyTextField
                                                    initialCurrencySymbol={currencyCustomerSymbol1}
                                                    initialCurrencyValue={part.net_SalesPrice}
                                                    currencyList={currencyList}
                                                    onCurrencyChange={(newValue) => {
                                                        const updatedPart = { ...part, net_SalesPrice: newValue };
                                                        const updatedParts = [...selectedParts];
                                                        updatedParts[index] = updatedPart;
                                                        setSelectedParts(updatedParts);
                                                    }}
                                                    disabled={true}
                                                />
                                            </td>
                                            <td className="no-wrap" style={{ "width": "10%" }}>
                                                <CurrencyTextField
                                                    initialCurrencySymbol={currencyCustomerSymbol1}
                                                    initialCurrencyValue={part.net_VATPrice}
                                                    currencyList={currencyList}
                                                    onCurrencyChange={(newValue) => {
                                                        const updatedPart = { ...part, net_VATPrice: newValue };
                                                        const updatedParts = [...selectedParts];
                                                        updatedParts[index] = updatedPart;
                                                        setSelectedParts(updatedParts);
                                                    }}
                                                    disabled={true}
                                                />
                                            </td>
                                            <td style={{ "textAlign": "right", "width": "8%" }}>

                                                <a style={{ "background": "none", "border": "none", "marginLeft": "3px" }} className={`text-danger ${parseInt(isLock) > 0 || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={() => removeRow(index)} disabled={isClosed === '1' || isClosed === 1 || isLock.toString() === "1"}>
                                                    <i className="icofont-ui-delete" aria-hidden="true"></i>
                                                </a>
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>

                        </div>
                    </div>
                    {/* Add more form fields as needed */}

                    <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                        <label htmlFor="int_DiscountType" className="col-sm-2 col-form-label">Discount</label>
                        <div className="col-sm-4">
                            <select name="int_DiscountType" className='form-control' value={formData.int_DiscountType} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1}>
                                <option value="0">Select Discount</option>
                                {DiscountsList.map((discount) => (
                                    <option key={discount.PK_DiscountType_ID} value={discount.PK_DiscountType_ID}>
                                        {discount.vc_Name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {formData.CourierID > 0 && (
                            <>
                                <label htmlFor="dec_DiscountAmount" className="col-sm-2 col-form-label">Carriage Cost</label>
                                <div className="col-sm-4">

                                    <input type='text' name="mon_DeliveryNetTotal" value={formData.mon_DeliveryNetTotal} onChange={handleFieldChange} class='form-control'></input>
                                </div>
                            </>
                        )}
                    </div>
                    <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                        <label htmlFor="dec_DiscountAmount" className="col-sm-2 col-form-label">Discount Amount</label>
                        <div className="col-sm-4">
                            <input type="text" className="form-control" name="dec_DiscountAmount" value={formData.dec_DiscountAmount} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                        </div>
                        <label htmlFor="dec_DiscountNETTotal" className="col-sm-2 col-form-label">Discount</label>
                        <div className="col-sm-2">

                            <CurrencyTextField
                                initialCurrencySymbol={currencyCustomerSymbol1}
                                initialCurrencyValue={formData.dec_DiscountNETTotal}
                                currencyList={currencyList}

                                disabled={true}
                            />
                        </div>

                        <div className="col-sm-2">

                        </div>
                    </div>
                    <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                        <label htmlFor="dec_DiscountAmount" className="col-sm-6 col-form-label"></label>
                        <label htmlFor="int_DiscountType" className="col-sm-2 col-form-label">Orders Total</label>
                        <div className="col-sm-2">

                            <CurrencyTextField
                                initialCurrencySymbol={currencyCustomerSymbol1}
                                initialCurrencyValue={formData.mon_TotalPrice}
                                currencyList={currencyList}

                                disabled={true}
                            />
                        </div>

                        <div className="col-sm-2">
                            <input type="text" className="form-control" name="mon_TotalPriceO" value={formData.mon_TotalPriceO} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                        </div>
                    </div>
                    <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                        <label htmlFor="dec_DiscountAmount" className="col-sm-6 col-form-label"></label>
                        <label htmlFor="int_DiscountType" className="col-sm-2 col-form-label">Grand Total</label>
                        <div className="col-sm-2">
                            <CurrencyTextField
                                initialCurrencySymbol={currencyCustomerSymbol1}
                                initialCurrencyValue={formData.mon_TotalPriceG}
                                currencyList={currencyList}

                                disabled={true}
                            />
                        </div>

                        <div className="col-sm-2">

                            <CurrencyTextField
                                initialCurrencySymbol={BaseCurrency}
                                initialCurrencyValue={parseFloat(formData.mon_TotalPriceG) / parseFloat(convRate).toFixed(2)}
                                currencyList={currencyList}

                                disabled={true}
                            />
                        </div>
                    </div>
                </div>
                <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                    <div className="col-sm-7">
                        {(assignedModules.has(MODULE_IDS.Parts) &&
                            <button style={{ background: "#00796B" }} type="button" className={`btn btn-primary ${parseInt(isLock) > 0 || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={() => setShowPartModal(true)} disabled={isClosed === '1' || isClosed === 1 || !assignedModules.has(MODULE_IDS.Parts) || isLock.toString() === "1"}>
                                <i className="icofont-plus" aria-hidden="true"> Add Item </i>
                            </button>
                        )}
                        <button style={{ "marginLeft": "5px", background: "#0288D1" }} type="button" className={`btn btn-secondary ${parseInt(isLock) > 0 || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleAddRow} disabled={isClosed === '1' || isClosed === 1 || isLock.toString() === "1"} >
                            <i className="icofont-plus" aria-hidden="true">Add Text</i>
                        </button>
                        <button style={{ "marginLeft": "5px", background: "#2E7D32" }} type="button" className={`btn btn-dark ${parseInt(isLock) > 0 || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={(event) => handleShippment(event, InvoiceID)} disabled={InvoiceID === '0' || InvoiceID === 0 || isLock.toString() === "1"}>
                            <img style={{ "width": "10px" }} src="assets/img/icons/sale.png" alt="Add icon" />  Post
                        </button>


                    </div>
                    <div className="col-sm-5">
                        <button onClick={() => onClose(isChanged)} type="button" className={`btn btn-danger`} style={{ float: "right", "marginLeft": "5px" }}>
                            <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                        </button>
                        <button type="submit" className={`btn btn-primary ${parseInt(isLock) > 0 || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} style={{ "float": "right", "marginLeft": "5px" }} disabled={isClosed === '1' || isClosed === 1 || isLock.toString() === "1"}>
                            <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />
                            {InvoiceID > 0 ? ' Update' : ' Save'}

                        </button>
                        <button style={{ "marginLeft": "5px", "float": "right" }} type="button" className="btn btn-secondary" onClick={generatePDF}>
                            <img src="assets/img/resources/printer-icon.png" alt="Add icon" style={{ height: "10px" }} />  Print
                        </button>
                        <button style={{ "marginLeft": "5px", "float": "right" }} type="button" className="btn btn-email" onClick={generatePDFForEmail}>
                            <i className="icofont-email" aria-hidden="true"></i> Email
                        </button>

                    </div>
                </div>
            </form>
            {showPdfModal && pdfUrl && (
                <div className="modal fade show d-block" tabIndex="-1">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Generated PDF</h5>
                                <button type="button" className="close" onClick={() => setPdfUrl(null)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <iframe
                                    id="pdf-iframe"
                                    src={pdfUrl}
                                    title="PDF Viewer"
                                    style={{ width: '100%', height: '600px', border: 'none' }}
                                />
                            </div>
                            <div className="modal-footer">
                                <button
                                    className="btn btn-primary"
                                    onClick={() => {
                                        const iframe = document.querySelector('iframe');
                                        if (iframe) iframe.contentWindow.print(); // Trigger print
                                    }}
                                >
                                    Print
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {ShowInvoiceHistoryModal && (
                <div className="modal fade show" style={{ display: 'block' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Invoice Item History</h5>
                                <button type="button" className="btn-close" onClick={() => setShowInvoiceHistoryModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                <table className="table table-bordered">
                                    <thead>
                                        <th>Location</th>
                                        <th>Quanity</th>
                                    </thead>
                                    <tbody>
                                        {InvoiceItemHistory.map((depot) => (
                                            <tr>
                                                <td key={depot.ID}>
                                                    {depot.vc_BayName}
                                                </td>
                                                <td>{depot.dec_Quanity}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            )}
            {(showDescriptionModal &&
                <DescriptionModal
                    show={showDescriptionModal}
                    text={descriptionText}
                    position={modalPosition}
                />
            )}
            <PartSelectionModal
                show={showPartModal}
                onClose={() => setShowPartModal(false)}
                parts={partList}
                onSelectPart={handlePartSelect}
                ClientCompanyID={formData.CustomerID}
            />
            <CustomerSelectionModal
                show={showCustomerModal}
                onClose={() => setShowCustomerModal(false)}
                customers={CustomerList}
                onSelectCustomer={handleCustomerSelect}
            />
            {showShippedModal && bnt_OrderNumber &&
                <InvoiceShippedModel
                    show={showShippedModal}
                    OnSuccess={handleSuccess}
                    onClose={handleCloseShippmentModal}
                    parts={InvoiceItems}
                    setParts={setInvoiceItems}
                    bnt_OrderNumber={bnt_OrderNumber}
                    InvoiceID={InvoiceID}


                />
            }
            {isEmailModalOpen && (

                <SendEmail
                    onClose={handleCloseEmailModal}
                    ToEmail={Email}
                    pdfAttachment={pdfAttachment}
                    setPdfAttachment={setPdfAttachment}   // ✅ ADD THIS
                    getMergedPDFBlob={getMergedPDFBlob}   // ✅ ADD THIS
                    ReportName="Invoice.pdf"
                />
            )}
            {showDepotModal && (
                <div className="modal fade show" style={{ display: 'block' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Select Depot</h5>
                                <button type="button" className="btn-close" onClick={() => setShowDepotModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                <table className="table">
                                    {stockLocationList.map((depot) => (
                                        <tr>
                                            <td
                                                key={depot.PK_StockLocation_ID}
                                                className="list-group-item"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => handleDepotSelect(depot)}
                                            >
                                                {depot.vc_Name}
                                            </td>
                                            <td>
                                                {depot.dec_Quantity}
                                            </td>
                                        </tr>
                                    ))}
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            )}

        </div >


    );
}
export default CreateInvoice;

